import { useEffect } from 'react'
import { netWorth } from './finance.js'
import { updateAt } from './firebase.js'
import { todayISO } from './format.js'

/**
 * Replaces the spreadsheet's daily row: keeps today's net-worth snapshot in sync
 * with current balances (past days are left untouched, so history is preserved).
 */
export function useDailySnapshot(data) {
  useEffect(() => {
    if (!data || !data.accounts) return
    const today = todayISO()
    const { assets, debt, byCategory } = netWorth(data, today)
    const next = { assets: Math.round(assets), debt: Math.round(debt), byCategory: roundAll(byCategory) }
    const cur = data.snapshots?.[today]
    if (cur && cur.assets === next.assets && cur.debt === next.debt && JSON.stringify(cur.byCategory || {}) === JSON.stringify(next.byCategory)) return
    updateAt(`snapshots/${today}`, next)
  }, [data])
}

const roundAll = (o) => Object.fromEntries(Object.entries(o).sort().map(([k, v]) => [k, Math.round(v)]))
